// Ported (simplified) from LC2 (src/commons/components/@extended/LoadingBox.js) — kept
// as a minimal spinner box for TokenVerification until the new UI defines a loading state.
import React from 'react';
import PropTypes from 'prop-types';
import {Box, CircularProgress} from '@mui/material';

const LoadingBox = ({width = '100%', height = 200}) => (
    <Box width={width} height={height} display="flex" justifyContent="center" alignItems="center">
        <CircularProgress size={20} thickness={1} />
    </Box>
);

LoadingBox.propTypes = {
    width: PropTypes.string,
    height: PropTypes.number
};

export default LoadingBox;
